'use client';
import { Anchor, AnchorProps } from '@repo/ui/src/components/Anchor';
import HeaderPaddingWrapper from '@repo/ui/src/components/HeaderPaddingWrapper';
import NavLinks, { LinkProps } from './_NavLinks';
import { classNames } from '@repo/ui/src/utils/classNames';
import { useEffect } from 'react';

interface Props {
  primaryText?: string;
  secondaryText?: string;
  buttonLink?: AnchorProps;
  navLinks?: Array<LinkProps>;
}

const StickyNavWithLinks = ({ navLinks, buttonLink, primaryText, secondaryText }: Props) => {
  useEffect(() => {
    const stickyNavElement = document.querySelector('.sticky-nav-with-links-component');

    if (stickyNavElement) {
      const height = (stickyNavElement as HTMLElement).offsetHeight;
      document.documentElement.style.setProperty('--sticky-nav-height', `${height}px`);
    }

    return () => {
      document.documentElement.style.setProperty('--sticky-nav-height', '0px');
    };
  }, []);

  return (
    <HeaderPaddingWrapper
      className="sticky-nav-with-links-component tw-grid tw-grid-cols-[auto_1fr_auto] tw-sticky tw-top-[var(--navTop)] tw-left-0 tw-w-full tw-bg-neutral-800 tw-items-center tw-z-[400] tw-overflow-hidden tw-py-2"
      as='nav'
    >
      <h3 className="tra-text-web-sub-1 tw-text-neutral-50 tw-mr-4">
        {(primaryText || secondaryText) && (
          <span>
            {primaryText} {secondaryText && (<span>{secondaryText}</span>)}
          </span>
        )}
      </h3>

      <NavLinks
        navLinks={navLinks}
        className={classNames(
          'tw-flex',
          !primaryText && !secondaryText ? '-tw-ml-4' : ''
        )}
      />

      <div>
        <Anchor
          {...buttonLink}
          className="tra-text-web-utl-button-s tw-bg-brand-400 tw-text-neutral-50 tw-py-3 tw-px-5 tw-transition-all tw-duration-300 hover:tw-bg-brand-400 lg:tw-py-3 lg:tw-px-10"
        >
          {buttonLink?.displayName}
        </Anchor>
      </div>
    </HeaderPaddingWrapper>
  );
};

export default StickyNavWithLinks;